export default __webpack_public_path__ + "static/media/mail.2e8c73d9.svg";